var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-input-group',{attrs:{"prepend":_vm.currency}},[_c('b-form-input',{attrs:{"type":"number","value":_vm.value},on:{"input":_vm.changeValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }